import { render, staticRenderFns } from "./ListSubRegion.vue?vue&type=template&id=4b3dc1d6&scoped=true&"
import script from "./ListSubRegion.vue?vue&type=script&lang=js&"
export * from "./ListSubRegion.vue?vue&type=script&lang=js&"
import style0 from "./ListSubRegion.vue?vue&type=style&index=0&id=4b3dc1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dc1d6",
  null
  
)

export default component.exports